import { render, staticRenderFns } from "./ProjectAnalytics.vue?vue&type=template&id=9ea17a24&scoped=true&"
import script from "./ProjectAnalytics.vue?vue&type=script&lang=ts&"
export * from "./ProjectAnalytics.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAnalytics.vue?vue&type=style&index=0&id=9ea17a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea17a24",
  null
  
)

export default component.exports